const colors = {
  active: '#fe8b07',
  badgebg: '#ff8a06',
  border: '#cccccc',
  color6: '#666666',
};

export default colors;
